import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const InputStyled = styled.input`
  border-width:0px;
  border:none;
  width: auto;
  font-size: 10px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  margin-left: 8px;
  padding: 4px;
`;

export const WrapperOptions = styled.ul`
  position: absolute;
  margin-left: 8px;
  top: 30px;
  left: -18px;
  z-index: 10;
  display: flex;
  flex: 1;
  width: 245px;
  flex-direction: column;
  border: 1px solid #eee;
  background: #fff;
  padding: 10px;
 
  li{
    font-family: 'Roboto', sans-serif;
    font-size: 11px;
    list-style-type: none;
    padding: 5px;
    
    :hover{
      background-color: #E4F2FC;
      color: #7C91A0;
      cursor: pointer;
    }
  }
`;
